module.exports = __webpack_public_path__ + "img/applications.54185162.svg";